import Bugsnag from '@bugsnag/js'

import packageJson from '../../../package.json'
import ApiError from '../../common/api/exceptions'
import { parseResponse } from '../../common/utils'
import { BUGSNAG_API_KEY, ENVNAME } from '../../constants/environment'

const bugsnag = BUGSNAG_API_KEY
  ? Bugsnag.start({
      apiKey: BUGSNAG_API_KEY,
      appVersion: packageJson.version,
      releaseStage: ENVNAME,
      autoDetectErrors: false,
      autoTrackSessions: false,
      enabledBreadcrumbTypes: [],
      onError: event => {
        if (event.originalError instanceof ApiError) {
          const error = event.originalError
          if (error.request) {
            event.addMetadata('api_request', error.request)
          }

          if (error.response) {
            event.addMetadata('api_response', parseResponse(error))
          }
        }
      },
    })
  : undefined

const notifyError = (error: unknown) => {
  if (ENVNAME === 'local') {
    throw error
  }

  if (!bugsnag) {
    console.error('[ccn-widget] Unable to log error, Error reporting module was not loaded')
    return
  }

  bugsnag.notify(error instanceof Error ? error : new Error(`${error}`))
}

export { notifyError }
